<template>
  <div>
    {{waitCount}}
  </div>
</template>

<script>
//import {requestWaitCount} from "../api";

export default {
  name: "TestCount",
  data(){
    return {
     waitCount: {}
    }
  },
  created() {
    this.getWaitCount()
  },
  methods:{
    async getWaitCount(){
      const response = await requestWaitCount({})
      console.log(response.data)
      this.waitCount = response.data
    }
  }
}
</script>

<style scoped>

</style>
